export const sleep = ms => {
  return new Promise(resolve => {
    const timeout = setTimeout(resolve, ms);
    return () => clearTimeout(timeout);
  });
};
